<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Vet-Manage",
  path: "manage",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
